module.exports = __webpack_public_path__ + "img/element-datetime_picker.4a0e65b.svg";